import { useQuery } from '@tanstack/react-query';
import * as scans from '@/api/endpoints/scanAnalytics';

export const useScanSummary = (filters: scans.ScanFilters, enabled = true) =>
  useQuery({
    queryKey: ['scan-analytics', 'summary', filters],
    queryFn: () => scans.getSummary(filters),
    enabled,
  });
export const useScanTrend = (
  filters: scans.ScanFilters,
  granularity: 'day' | 'week' = 'day',
  enabled = true,
) =>
  useQuery({
    queryKey: ['scan-analytics', 'trend', filters, granularity],
    queryFn: () => scans.getTrend(filters, granularity),
    enabled,
  });
export const useScanModels = (filters: scans.ScanFilters, enabled = true) =>
  useQuery({
    queryKey: ['scan-analytics', 'models', filters],
    queryFn: () => scans.getByModel(filters),
    enabled,
  });
export const useScanCorrectionProgress = (filters: scans.ScanFilters, enabled = true) =>
  useQuery({
    queryKey: ['scan-analytics', 'correction-progress', filters],
    queryFn: () => scans.getCorrectionProgress(filters),
    enabled,
  });
export const useScanCorrections = (filters: scans.ScanFilters, enabled = true) =>
  useQuery({
    queryKey: ['scan-analytics', 'corrections', filters],
    queryFn: () => scans.getCorrections(filters),
    enabled,
  });
